import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthService } from '../../services/auth.service';
import { ContactActionsService } from '../../services/contact-actions.service';
import { ContactService } from '../../services/contact.service';

@Component({
  selector: 'app-footer',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent implements OnInit {
  protected readonly auth = inject(AuthService);
  private readonly contact = inject(ContactService);
  private readonly contactActions = inject(ContactActionsService);

  private readonly destroyRef = inject(DestroyRef);

  protected readonly year = signal(new Date().getFullYear());
  protected readonly showMessageDialog = signal(false);
  protected readonly showWechatQR = signal(false);
  protected readonly email = signal('');
  protected readonly subject = signal('');
  protected readonly description = signal('');
  protected readonly isSending = signal(false);

  protected toggleWechatQR(): void {
    this.showWechatQR.update((v) => !v);
  }

  protected closeWechatQR(): void {
    this.showWechatQR.set(false);
  }

  protected openMessageDialog(): void {
    this.email.set('');
    this.subject.set('');
    this.description.set('');
    this.showMessageDialog.set(true);
  }

  protected closeMessageDialog(): void {
    if (!this.isSending()) {
      this.showMessageDialog.set(false);
    }
  }

  ngOnInit(): void {
    this.contactActions.onOpenMessage.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      if (this.auth.isAuthenticated()) this.openMessageDialog();
    });
    this.contactActions.onToggleWechat.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.toggleWechatQR();
    });
  }

  protected sendMessage(): void {
    const em = this.email().trim();
    const sub = this.subject().trim();
    const desc = this.description().trim();
    if (!em || !sub || !desc) return;
    this.isSending.set(true);
    this.contact.sendMessage(em, sub, desc).subscribe({
      next: () => {
        this.isSending.set(false);
        this.showMessageDialog.set(false);
      },
      error: () => {
        this.isSending.set(false);
      },
    });
  }
}
